import React from 'react';
import Transition, {TransitionProps} from 'react-transition-group/Transition';

const defaultDuration = 155; //ms

export type TransitionTimeout = number | {appear?: number; enter?: number; exit?: number} | undefined;
export type TimeoutType = 'appear' | 'enter' | 'exit';

const defaultTimeout: TransitionTimeout = {
  appear: 0,
  enter: defaultDuration,
  exit: defaultDuration,
};

export const getTransitionDuration = (timeout: TransitionTimeout, type: TimeoutType) => {
  if (!timeout) return defaultDuration;

  if (typeof timeout === 'number') {
    return timeout;
  }

  if (typeof timeout === 'object') {
    return timeout[type] || defaultTimeout[type] || defaultDuration;
  }

  return defaultDuration;
};

export type TransitionRootProps = Omit<TransitionProps, 'timeout' | 'nodeRef'> & {
  timeout?: TransitionTimeout;
  nodeRef?: React.Ref<HTMLElement> | undefined;
};

export const TransitionRoot: React.FC<TransitionRootProps> = ({timeout = defaultTimeout, ...restProps}) => {
  return <Transition timeout={timeout} {...restProps} />;
};

export default TransitionRoot;
